var map = {
	"./applied-ict": [
		400,
		400
	],
	"./applied-ict.tsx": [
		400,
		400
	],
	"./applied-science": [
		4918,
		4918
	],
	"./applied-science.tsx": [
		4918,
		4918
	],
	"./art": [
		8692,
		8692
	],
	"./art.tsx": [
		8692,
		8692
	],
	"./biology": [
		4369,
		4369
	],
	"./biology.tsx": [
		4369,
		4369
	],
	"./buddhism": [
		5460,
		5460
	],
	"./buddhism.tsx": [
		5460,
		5460
	],
	"./built-environment": [
		442,
		442
	],
	"./built-environment.tsx": [
		442,
		442
	],
	"./business": [
		8088,
		8088
	],
	"./business.tsx": [
		8088,
		8088
	],
	"./chemistry": [
		5989,
		5989
	],
	"./chemistry.tsx": [
		5989,
		5989
	],
	"./childrens-care-play-learning-and-development": [
		7268,
		7268
	],
	"./childrens-care-play-learning-and-development.tsx": [
		7268,
		7268
	],
	"./christianity": [
		4255,
		4255
	],
	"./christianity.tsx": [
		4255,
		4255
	],
	"./computer-sci": [
		9436,
		9436
	],
	"./computer-sci.tsx": [
		9436,
		9436
	],
	"./computer-science": [
		2519,
		2519
	],
	"./computer-science.tsx": [
		2519,
		2519
	],
	"./construction": [
		6409,
		6409
	],
	"./construction.tsx": [
		6409,
		6409
	],
	"./creative-media-and-performing-arts": [
		2423,
		2423
	],
	"./creative-media-and-performing-arts.tsx": [
		2423,
		2423
	],
	"./criminology": [
		3903,
		3903
	],
	"./criminology.tsx": [
		3903,
		3903
	],
	"./design-and-technology": [
		318,
		318
	],
	"./design-and-technology.tsx": [
		318,
		318
	],
	"./design-tech": [
		4875,
		4875
	],
	"./design-tech.tsx": [
		4875,
		4875
	],
	"./digital-tech": [
		7687,
		7687
	],
	"./digital-tech.tsx": [
		7687,
		7687
	],
	"./digital-technology": [
		628,
		628
	],
	"./digital-technology.tsx": [
		628,
		628
	],
	"./drama": [
		9356,
		9356
	],
	"./drama.tsx": [
		9356,
		9356
	],
	"./economics": [
		4740,
		4740
	],
	"./economics.tsx": [
		4740,
		4740
	],
	"./electronics": [
		8977,
		8977
	],
	"./electronics.tsx": [
		8977,
		8977
	],
	"./engLitLang": [
		1768,
		1768
	],
	"./engLitLang.tsx": [
		1768,
		1768
	],
	"./engineering": [
		5017,
		5017
	],
	"./engineering.tsx": [
		5017,
		5017
	],
	"./english": [
		3048,
		3048
	],
	"./english-language": [
		3884,
		3884
	],
	"./english-language.tsx": [
		3884,
		3884
	],
	"./english-literature": [
		6536,
		6536
	],
	"./english-literature.tsx": [
		6536,
		6536
	],
	"./english.tsx": [
		3048,
		3048
	],
	"./essential-communication-skills": [
		534,
		534
	],
	"./essential-communication-skills.tsx": [
		534,
		534
	],
	"./essential-digital-literacy-skills": [
		6401,
		6401
	],
	"./essential-digital-literacy-skills.tsx": [
		6401,
		6401
	],
	"./essential-employability-of-number-skills": [
		1070,
		1070
	],
	"./essential-employability-of-number-skills.tsx": [
		1070,
		1070
	],
	"./essential-employability-skills": [
		5948,
		5948
	],
	"./essential-employability-skills.tsx": [
		5948,
		5948
	],
	"./essential-skills-for-work-and-life": [
		9577,
		9577
	],
	"./essential-skills-for-work-and-life.tsx": [
		9577,
		9577
	],
	"./event-op": [
		6032,
		6032
	],
	"./event-op.tsx": [
		6032,
		6032
	],
	"./extend project": [
		3047,
		3047
	],
	"./extend project.tsx": [
		3047,
		3047
	],
	"./film": [
		3767,
		3767
	],
	"./film-studies": [
		229,
		229
	],
	"./film-studies.tsx": [
		229,
		229
	],
	"./film.tsx": [
		3767,
		3767
	],
	"./food": [
		3601,
		3601
	],
	"./food-and-nutrition": [
		7305,
		7305
	],
	"./food-and-nutrition.tsx": [
		7305,
		7305
	],
	"./food-science-and-nutrition": [
		347,
		347
	],
	"./food-science-and-nutrition.tsx": [
		347,
		347
	],
	"./food.tsx": [
		3601,
		3601
	],
	"./french": [
		9,
		9
	],
	"./french.tsx": [
		9,
		9
	],
	"./geography": [
		4624,
		4624
	],
	"./geography.tsx": [
		4624,
		4624
	],
	"./geology": [
		489,
		489
	],
	"./geology.tsx": [
		489,
		489
	],
	"./german": [
		2621,
		2621
	],
	"./german.tsx": [
		2621,
		2621
	],
	"./global-business-communication": [
		7291,
		7291
	],
	"./global-business-communication.tsx": [
		7291,
		7291
	],
	"./global-communication": [
		4401,
		4401
	],
	"./global-communication.tsx": [
		4401,
		4401
	],
	"./government-and-politics": [
		4240,
		4240
	],
	"./government-and-politics.tsx": [
		4240,
		4240
	],
	"./health-and-social-care": [
		3043,
		3043
	],
	"./health-and-social-care.tsx": [
		3043,
		3043
	],
	"./healthy-living-and-fitness": [
		6232,
		6232
	],
	"./healthy-living-and-fitness.tsx": [
		6232,
		6232
	],
	"./hinduism": [
		8751,
		8751
	],
	"./hinduism.tsx": [
		8751,
		8751
	],
	"./history": [
		4741,
		4741
	],
	"./history.tsx": [
		4741,
		4741
	],
	"./home-economics": [
		9581,
		9581
	],
	"./home-economics.tsx": [
		9581,
		9581
	],
	"./hospitality-and-catering": [
		5806,
		5806
	],
	"./hospitality-and-catering.tsx": [
		5806,
		5806
	],
	"./humanities": [
		7912,
		7912
	],
	"./humanities.tsx": [
		7912,
		7912
	],
	"./ict": [
		7660,
		7660
	],
	"./ict.tsx": [
		7660,
		7660
	],
	"./independent-living": [
		2232,
		2232
	],
	"./independent-living.tsx": [
		2232,
		2232
	],
	"./introduction-to-advanced-manufacturing-technologies-semiconductors": [
		5637,
		5637
	],
	"./introduction-to-advanced-manufacturing-technologies-semiconductors.tsx": [
		5637,
		5637
	],
	"./islam": [
		498,
		498
	],
	"./islam.tsx": [
		498,
		498
	],
	"./judaism": [
		196,
		196
	],
	"./judaism.tsx": [
		196,
		196
	],
	"./language-pathways": [
		7075,
		7075
	],
	"./language-pathways.tsx": [
		7075,
		7075
	],
	"./latin": [
		9622,
		9622
	],
	"./latin.tsx": [
		9622,
		9622
	],
	"./law": [
		6146,
		6146
	],
	"./law.tsx": [
		6146,
		6146
	],
	"./leisure-travel-tourism": [
		1188,
		1188
	],
	"./leisure-travel-tourism.tsx": [
		1188,
		1188
	],
	"./mathematics": [
		1971,
		1971
	],
	"./mathematics.tsx": [
		1971,
		1971
	],
	"./media": [
		8935,
		8935
	],
	"./media-studies": [
		7545,
		7545
	],
	"./media-studies.tsx": [
		7545,
		7545
	],
	"./media.tsx": [
		8935,
		8935
	],
	"./medical-sci": [
		6126,
		6126
	],
	"./medical-sci.tsx": [
		6126,
		6126
	],
	"./music": [
		3541,
		3541
	],
	"./music.tsx": [
		3541,
		3541
	],
	"./pathways-to-employment": [
		5586,
		5586
	],
	"./pathways-to-employment.tsx": [
		5586,
		5586
	],
	"./pe": [
		8286,
		8286
	],
	"./pe.tsx": [
		8286,
		8286
	],
	"./performing-arts": [
		2649,
		2649
	],
	"./performing-arts.tsx": [
		2649,
		2649
	],
	"./personal-and-social-development": [
		6073,
		6073
	],
	"./personal-and-social-development.tsx": [
		6073,
		6073
	],
	"./personal-progress": [
		4718,
		4718
	],
	"./personal-progress.tsx": [
		4718,
		4718
	],
	"./philosophy-of-religion": [
		7546,
		7546
	],
	"./philosophy-of-religion.tsx": [
		7546,
		7546
	],
	"./physics": [
		4315,
		4315
	],
	"./physics.tsx": [
		4315,
		4315
	],
	"./preparing-for-employment": [
		7025,
		7025
	],
	"./preparing-for-employment.tsx": [
		7025,
		7025
	],
	"./preparing-for-work": [
		7199,
		7199
	],
	"./preparing-for-work.tsx": [
		7199,
		7199
	],
	"./psychology": [
		9593,
		9593
	],
	"./psychology.tsx": [
		9593,
		9593
	],
	"./rel-and-ethics": [
		2377,
		2377
	],
	"./rel-and-ethics.tsx": [
		2377,
		2377
	],
	"./religious-studies": [
		3921,
		3921
	],
	"./religious-studies.tsx": [
		3921,
		3921
	],
	"./retail-business": [
		7657,
		7657
	],
	"./retail-business.tsx": [
		7657,
		7657
	],
	"./science": [
		4699,
		4699
	],
	"./science.tsx": [
		4699,
		4699
	],
	"./securing-employment": [
		7819,
		7819
	],
	"./securing-employment.tsx": [
		7819,
		7819
	],
	"./self-development-and-wellbeing": [
		6413,
		6413
	],
	"./self-development-and-wellbeing.tsx": [
		6413,
		6413
	],
	"./sikhism": [
		1228,
		1228
	],
	"./sikhism.tsx": [
		1228,
		1228
	],
	"./sociology": [
		8849,
		8849
	],
	"./sociology.tsx": [
		8849,
		8849
	],
	"./spanish": [
		3481,
		3481
	],
	"./spanish.tsx": [
		3481,
		3481
	],
	"./sport": [
		1156,
		1156
	],
	"./sport-and-coaching-principles": [
		5924,
		5924
	],
	"./sport-and-coaching-principles.tsx": [
		5924,
		5924
	],
	"./sport.tsx": [
		1156,
		1156
	],
	"./sustainability": [
		1943,
		1943
	],
	"./sustainability.tsx": [
		1943,
		1943
	],
	"./tourism": [
		4534,
		4534
	],
	"./tourism.tsx": [
		4534,
		4534
	],
	"./travel": [
		5553,
		5553
	],
	"./travel.tsx": [
		5553,
		5553
	],
	"./wellbeing": [
		3437,
		3437
	],
	"./wellbeing.tsx": [
		3437,
		3437
	],
	"./welsh": [
		2149,
		2149
	],
	"./welsh-language": [
		8702,
		8702
	],
	"./welsh-language-and-literature": [
		2196,
		2196
	],
	"./welsh-language-and-literature.tsx": [
		2196,
		2196
	],
	"./welsh-language.tsx": [
		8702,
		8702
	],
	"./welsh-literature": [
		5415,
		5415
	],
	"./welsh-literature.tsx": [
		5415,
		5415
	],
	"./welsh-second": [
		659,
		659
	],
	"./welsh-second.tsx": [
		659,
		659
	],
	"./welsh.tsx": [
		2149,
		2149
	],
	"./work-welsh": [
		8308,
		8308
	],
	"./work-welsh.tsx": [
		8308,
		8308
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 8167;
module.exports = webpackAsyncContext;